const supportedLanguages = [
  {
    key: "en",
    value: "ENG",
  },
  {
    key: "tr",
    value: "TUR",
  },
  {
    key: "es",
    value: "ESP",
  },
  {
    key: "pt",
    value: "PRT",
  },
  {
    key: "it",
    value: "ITA",
  },
  {
    key: "de",
    value: "GER",
  },
  {
    key: "fr",
    value: "FRE",
  },
  {
    key: "el",
    value: "GRE",
  },
  {
    key: "sr",
    value: "SRP",
  },
  {
    key: "nl",
    value: "DUT",
  },
  {
    key: "hu",
    value: "HUN",
  },
  {
    key: "th",
    value: "THA",
  },
  {
    key: "pt_BR",
    value: "BRA"
  }
];

export default supportedLanguages;
